import { colorsPalettes } from "@similarweb/styles";

import { SwitchPackageBanner } from "app/components/PackageSwitcher/components/SwitchPackageBanner/SwitchPackageBanner";
import type { IBannerState } from "app/components/PackageSwitcher/components/SwitchPackageBanner/types";
import { translate } from "app/filters/i18nFilter";

import { PackageSwitcherErrorContent, PackageSwitcherErrorImage } from "./ErrorContent.styled";
import plant from "./images/plant.svg";

export const ErrorContent = () => {
    const bannerState: IBannerState = {
        message: translate("buyer_journey.switch_package.get_switch_options.error"),
        shouldDisplay: true,
        iconColor: colorsPalettes.red[500],
        bannerColor: colorsPalettes.red[100],
        textColor: colorsPalettes.red[500],
    };

    return (
        <>
            <SwitchPackageBanner bannerState={bannerState} />
            <PackageSwitcherErrorContent>
                <PackageSwitcherErrorImage
                    src={plant}
                    alt="plant"
                />
            </PackageSwitcherErrorContent>
        </>
    );
};
